import React from 'react';
import './styles.scss';
import { Icons } from '@hyperping/design';
import drago from '../../../pages/customers/assets/drago.png'
import blockCtaImg from './bg_cta.jpg';

const BlockCTA = ({ title, description, buttonText, buttonLink, bulletPoints = [], quote, style }) => {
  return (
    <div className="block-cta gap-1em flex br-6px padding-2em width-100 br-6px relative overflow-hidden" style={{maxWidth:'1160px',padding:'3em',...style}}>
      <div className="flex flex-direction-column" style={{ gap:'3em' }}>
        <div className="line-height-115em font-weight-500 color-text" style={{
          fontWeight: 400,
          fontSize: '42px',
          textAlign: 'center',
          maxWidth: '740px',
          margin: 'auto'
        }}>{title}</div>
        {description && <div className="mb-2em font-size-16px font-weight-300 line-height-143em color-text">{description}</div>}
        
        <div className="flex justify-content-space-between mt-2em">

        <div className="flex flex-direction-column gap-2em justify-content-space-between" style={{flex: '1 1 0px'}}>
          {bulletPoints && <div className="block-cta-bullets">
            {bulletPoints.map((bullet, index) => (
              <div key={index} className="block-cta-bullet flex gap-05em">
                <Icons style={{color:'#2bac76',width:'16px',height:'16px',marginTop:'3px'}} name="check" />
                <div className="font-size-16px font-weight-300 why-choose-block-p line-height-143em mb-05em color-text-secondary">{bullet}</div>
              </div>
            ))}
          </div>}

          <a href={buttonLink} className="block-cta-button plausible-event-name=Signup+attempt" style={{width:'fit-content'}}>
            {buttonText}
          </a>
        </div>

          {quote && <div className="flex flex-direction-column gap-1em" style={{flex: '1 1 0px'}}>
            <div className="font-size-18px font-weight-400 why-choose-block-p line-height-143em mb-05em color-text-secondary" style={{marginBottom:'30px'}}>{quote.text}</div>
            <div className="flex gap-1em">
              <img className="customer-picture" src={drago} style={{
                borderRadius: '50%',
                width: '46px',
                height: '46px'
              }} />
              <div className="flex flex-direction-column">
                <div className="font-size-16px font-weight-500 why-choose-block-p line-height-143em color-text">{quote.author}</div>
                <div className="font-size-16px font-weight-300 why-choose-block-p line-height-143em color-text-secondary">{quote.role}</div>
              </div>
            </div>
          </div>}
        </div>
      </div>
      <img 
        src={blockCtaImg}
        alt=""
        width={355}
        height={355}
        className="position-absolute bottom-0 left-0 width-100 height-full events-none"
        style={{
          zIndex: -1,
          objectPosition: 'center top',
          objectFit: 'cover',
          width: '100%',
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: '180%'
        }}
      />
    </div>
  )
}

export default BlockCTA;